<template>
  <v-radio-group v-model="radioGroup" :row="isRow ? true : false">
    <v-radio
      v-for="n in fieldLabel.length"
      :key="n"
      :label="fieldLabel[n - 1]"
      :value="n"
    ></v-radio>
  </v-radio-group>
</template>

<script>
export default {
  props: {
    fieldLabel: {
      type: Array,
      default: () => ['כן', 'לא'],
      required: false,
    },
    fieldIconName: {
      type: String,
      required: false,
    },
    fieldRequired: {
      type: Boolean,
      required: false,
      default: true,
    },
    isRow: {
      type: Boolean,
      required: false,
      default: true,
    },
    fieldIndex: {
      type: Number,
      required: false,
      default: -1,
    },
    fieldValue: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      model: '',
      noRule: [],
    };
  },

  computed: {
    radioGroup: {
      get() {
        return this.fieldValue ? 1 : 2;
      },
      set(val) {
        if (this.fieldIndex >= 0) {
          this.$emit('child-field', val, this.fieldIndex);
        } else {
          this.$emit('child-field', val);
        }
      },
    },
  },
};
</script>
